module.exports = __webpack_public_path__ + "static/media/text.fe870ac6.svg";